import React, { useState } from 'react';
import SbEditable from 'storyblok-react';
import styled from 'styled-components';

import Components from '../components';

const Accordion = (props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <SbEditable content={props.blok}>
      <Title onClick={() => setIsExpanded(!isExpanded)} size={props.blok.title_size || '0.9'}>
        <Expander isExpanded={isExpanded}>&rsaquo;</Expander> {props.blok.title}
      </Title>
      <Content isExpanded={isExpanded}>
        {props.blok.content.map((blok) =>
          React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
        )}
      </Content>
    </SbEditable>
  );
};

const Title = styled.strong`
  cursor: pointer;
  font-family: 'Graphik Bold';
  font-size: ${(props) => props.size}rem;
  font-weight: bolder;
  text-align: left;
`;

const Expander = styled.span`
  color: #2a96f4;
  display: inline-block;
  font-size: 1.5rem;
  font-weight: bolder;
  transition: all 0.1s;
  transform: ${(props) => (props.isExpanded ? 'rotate(90deg)' : 'none')};
`;

const Content = styled.div`
  height: ${(props) => (props.isExpanded ? 'auto' : '0px')};
  overflow: hidden;
`;

export default Accordion;
